module.exports = __webpack_public_path__ + "img/page-066.89659ad6.jpg";